import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors, FormArray } from '@angular/forms';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { GestionSAC } from '../../../class/gestionSAC';
import { GestionSACService } from '../../../service/gestionSAC/gestionSAC.service';
import { TranslateService } from '@ngx-translate/core';
import { Message, SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { formatDate } from '../../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-new-gestionSAC',
  templateUrl: './new-gestionSAC.component.html',
  styleUrls: ['./new-gestionSAC.component.scss']
})
export class NewGestionSACComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: GestionSAC;

    messages: Message[] = [];

    public promiseForm: Promise<any>;
    public form: FormGroup;

    public es: any;
    public trackingClassOptions: SelectItem[];
    public statesCommitmentOptions: SelectItem[];
    public save_exit: boolean;

    private id: number;
    public showPage: number = 0;

    constructor(

        public fb: FormBuilder,
        public gestionSACService: GestionSACService,
        public translate: TranslateService,
        public hasPermissionService: HasPermissionService,
        private notificationsService: NotificationsService,
        private router: Router,
        private route: ActivatedRoute,
    ) {

        this.save_exit = false;

        this.es = calendarES();

        this.trackingClassOptions = [
            {label: 'Personal visita', value: 'Personal visita'},
            {label: 'Contacto telefónico', value: 'Contacto telefónico'},
            {label: 'Virtual', value: 'Virtual'},
        ];

        this.statesCommitmentOptions = [
            {label: 'Abierto', value: 'Abierto'},
            {label: 'Pendiente', value: 'Pendiente'},
            {label: 'Finalizado', value: 'Finalizado'},
        ];

        var rol_company = this.hasRole(59);

    }

    ngOnInit() {
        this.id = +this.route.snapshot.paramMap.get('gestion_sac_id');
        // console.log("el id es " + this.id);
        if(this.id !== 0 && (this.id !== undefined)){
            var promiseLoc = this.gestionSACService.infoGestionSAC(this.id).toPromise().then(
            response =>{
                //console.log(response);
                this.edit = response.json();
                this.createForm(this.edit);
                this.listFieldsFormsArray(this.commitments,this.edit.commitment,"commitment");
                this.listFieldsFormsArray(this.contacts,this.edit.contact,"contact");
                this.showPage = 1;
            },
            error=>{
                this.notificationsService.growlNotify('error', 'ID ' + this.id + ' no encontrado');
                this.router.navigateByUrl('/pages/service-client/gestionSACs');
                // this.showPage = 1;
            }
            );
        }
        else {
            this.showPage = 1;
            this.createForm(null);
        }
    }

    public createForm(data:any = null){
      data = data || {
        id : undefined,
        company_id : '',
        venue_id : '',
        name_plant_venue_visited : null,
        employee_id : null,
        tracking_class : '',
        date_time_follow_up : null,
        management_made_client : '',
        date_time_client_exit : null,
        approved_by_client : null,
      };
      this.form = this.fb.group({
        id: new FormControl(data.id),
        company_id : new FormControl(data.company_id, Validators.compose([Validators.required])),
        venue_id : new FormControl(data.venue_id, Validators.compose([Validators.required])),
        name_plant_venue_visited : new FormControl(data.name_plant_venue_visited, Validators.compose([Validators.required])),
        employee_id : new FormControl(data.employee_id, Validators.compose([Validators.required])),
        tracking_class : new FormControl(data.tracking_class, Validators.compose([Validators.required])),
        date_time_follow_up : new FormControl(data.date_time_follow_up ? new Date(data.date_time_follow_up) : null , Validators.compose([Validators.required])),
        management_made_client : new FormControl(data.management_made_client, Validators.compose([Validators.required])),
        date_time_client_exit : new FormControl(data.date_time_client_exit ? new Date(data.date_time_client_exit) : null),
        approved_by_client : new FormControl(data.approved_by_client),
        commitments: this.fb.array([]),
        contacts: this.fb.array([])
      })
    }

    public cancelGestionSAC () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newGestionSAC(values);
    }

    public newGestionSAC(values) {
        values.commitments = this.datesCommitment(values.commitments);

        // if(this.edit){
        //   if ((this.edit.created_at == null || this.edit.created_at == '') && (values.statusvalues.status == ''))
        //     values.created_at = formatDate(new Date());
        //   else if (this.edit.created_at)
        //     values.created_at = formatDate(this.edit.created_at);
        // }

        values.company_id = values.company_id ? values.company_id.id : this.edit.company_id;
        // values.venue_id = values.venue_id ? values.venue_id.id : this.edit.venue_id;
        values.employee_id = values.employee_id ? values.employee_id.id : this.edit.employee_id;
        values.date_time_follow_up = (values.date_time_follow_up != '' && values.date_time_follow_up != null) ?  formatDate(values.date_time_follow_up ): null;
        values.date_time_client_exit = (values.date_time_client_exit != '' && values.date_time_client_exit != null) ?  formatDate(values.date_time_client_exit ): null;

        values.id = values.id == null ? undefined : values.id;

        if (values && this.form.valid) {
            const promise = (this.edit) ? this.gestionSACService.updateGestionSAC(this.edit.id, values) : this.gestionSACService.newGestionSAC(values);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                            this.router.navigateByUrl('/pages/service-client/gestionSACs');
                        }
                        this.edit = response.json();
                        // (this.form.controls['invoiceparticulars']).clear();
                        // let frmArray = this.form.get('invoiceparticulars') as FormArray;
                        this.listFieldsFormsArray(this.commitments,this.edit.commitment,"commitment");
                        this.listFieldsFormsArray(this.contacts,this.edit.contact,"contact");
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }
    clearFormArray = (formArray: FormArray) => {
        while (formArray.length !== 0) {
          formArray.removeAt(0)
        }
    }
    listFieldsFormsArray(formArrayLoc: FormArray,data:any[], execfunction: string)
    {
        this.clearFormArray(formArrayLoc);

        if(data.length>0){
            data.forEach(element => {
                if(execfunction=="commitment")
                    this.addCommitment(element);//execfunction(element);//
                else if(execfunction=="contact")
                    this.addContact(element);
            });
        }
    }
    get commitments() {
        return this.form.controls["commitments"] as FormArray;
    }
    addCommitment(data:any=null) {
        data = data || {date_start_compromise:null,date_end_compromise:null,state:this.statesCommitmentOptions[0].value, what_do:null,id:undefined};
        const commitmentForm = this.fb.group({
            date_start_compromise: [data.date_start_compromise ? new Date(data.date_start_compromise):null, Validators.required],
            date_end_compromise: [data.date_end_compromise ? new Date(data.date_end_compromise):null, Validators.required],
            state: [data.state, Validators.required],
            what_do: [data.what_do, Validators.required],
            id: [data.id]
        });
        this.commitments.push(commitmentForm);
        // console.log(this.commitments);
        return;
    }
    deleteCommitment(commitmentIndex: number) {
        this.commitments.removeAt(commitmentIndex);
    }
    public datesCommitment(commitments: any[])
    {
        commitments.forEach(element =>{
            element.date_start_compromise = formatDate(element.date_start_compromise);
            element.date_end_compromise = formatDate(element.date_end_compromise);
        });
        return commitments;
    }

    getFormValidationErrors(form) {
        let value = '';
        Object.keys(form.controls).forEach(key => {
            const controlErrors: ValidationErrors = form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
                });
            }
        });
        return (value);
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public hasRole(rol){

        var r: boolean = false;
        var role = JSON.parse(localStorage.getItem('profile')).roles[0].id;
        if(role == rol){
            r = true;
        }

        return (r);

    }

    get contacts() {
        return this.form.controls["contacts"] as FormArray;
    }

    addContact(data:any = null) {
        data = data || {name:null, email:null, phone:null, id:undefined};
        const contactForm = this.fb.group({
            name: [ data.name, Validators.compose([ Validators.required, Validators.minLength(5) ]) ],
            email: [ data.email, Validators.compose([ Validators.required, Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$') ]) ],
            phone: [ data.phone, Validators.compose([ Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$') ]) ],
            id: [ data.id ]
        });
        this.contacts.push(contactForm);
        // console.log(this.commitments);
        return;
    }

    deleteContact(contactIndex: number) {
        this.contacts.removeAt(contactIndex);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/gestionSACs/new-gestionSAC/new-gestionSAC.component.ts